import { Injectable } from "@angular/core";
import { FilterDataService } from "./filter-data.service";

@Injectable()
export class ShowConditionService {

    constructor(
      private filterDataService: FilterDataService
    ) {}

    checkShowCondition (checkvalue: any, checkschema: any) {
      let showTemp: boolean = true;
      if ( checkvalue && checkschema ) {
        if (checkschema.hasOwnProperty('showCondition') && checkschema.hasOwnProperty('paramCondition')) {
          if (checkschema.showCondition) {
            let showCondition = checkschema.showCondition;
            if (showCondition.length > 0) {
              showTemp = (checkschema.paramCondition == 'or') ? false : true;
              let beforeCondition: boolean = false;
              showCondition.forEach(element => {
                if (checkschema.paramCondition == 'or') {
                  for (let key in checkvalue) {
                    if (element.hasOwnProperty('paramCondition')) {
                      if (element.paramCondition == 'eq') {
                        if (element.paramKey == key) {
                          beforeCondition = (element.paramValue == checkvalue[key]) ? true : false;
                          const cek = (element.paramValue == checkvalue) ? true : false;
                          if (beforeCondition) {
                            showTemp = true
                          }
                          if (cek) {
                            return showTemp = true;
                          }
                        }
                      } else if (element.paramCondition == 'neq') {
                        if (element.paramKey == key) {
                          beforeCondition = (element.paramValue != checkvalue[key]) ? true : false;
                          if (beforeCondition) {
                            showTemp = true
                          }
                        }
                      } else if (element.paramCondition == 'not' && element.paramValue == 'notNull') {
                          const filter = this.filterDataService.filter(element.paramKey, checkvalue);
                          if ( filter ) {
                            showTemp = true
                          }
                      }
                    } else {
                      if (element.paramKey == key) {
                        beforeCondition = (element.paramValue == checkvalue[key]) ? true : false;
                        if (beforeCondition) {
                          showTemp = true
                        }
                      }
                    }
                  }
                } else if (checkschema.paramCondition == 'and') {
                  if (showTemp) {
                    for (let key in checkvalue) {
                      if (element.hasOwnProperty('paramCondition')) {
                        if (element.paramCondition == 'eq') {
                          if (element.paramKey == key) {
                            showTemp = (element.paramValue == checkvalue[key]) ? true : false;
                          }
                        } else if (element.paramCondition == 'neq') {
                          if (element.paramKey == key) {
                            showTemp = (element.paramValue != checkvalue[key]) ? true : false;
                          }
                        }
                      } else {
                        if (element.paramKey == key) {
                          showTemp = (element.paramValue == checkvalue[key]) ? true : false;
                        }
                      }
                    }
                  }
                }
              });
            }
          }
        }
      } else {
        console.log('show condition params not found');
      }
      return showTemp;
    }
}





// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/show-condition.service.ts